/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */

export enum CustomEventType {
  fdc3Ready = "fdc3Ready",
}
